import React from 'react';
import DesktopCalendar from './DesktopCalendar';

import './CabDayPicker.css';
import './DayPickerCabReset.css';

type DateRange = {
  from: Date;
  to: Date;
};

type DatePickerContainerProps = {
  fromDateSelect: () => void;
  toDateSelect: () => void;
  isMobileDevice: boolean;
  selectedFromDate: Date;
  selectedToDate: undefined | Date;
  saveDates: (DateRange) => void;
  closeCheckinPopup: () => void;
  handleFocus: () => void;
  changeFocusState: (string) => void;
  inputName: string;
  numberOfMonths?: number | undefined;
  fromMonth?: Date | undefined;
};
const DatePickerContainer = React.memo(
  ({
    fromDateSelect,
    toDateSelect,
    isMobileDevice,
    selectedFromDate,
    selectedToDate,
    saveDates,
    closeCheckinPopup,
    handleFocus,
    changeFocusState,
    inputName,
    numberOfMonths,
    fromMonth
  }: DatePickerContainerProps) => {
    return (
      <div className="datePickerContainer">
        <DesktopCalendar
          fromDateSelect={fromDateSelect}
          toDateSelect={toDateSelect}
          isMobileDevice={isMobileDevice}
          saveDates={saveDates}
          selectedFromDate={selectedFromDate}
          selectedToDate={selectedToDate}
          closeCheckinPopup={closeCheckinPopup}
          handleFocus={handleFocus}
          changeFocusState={changeFocusState}
          inputName={inputName}
          numberOfMonths={numberOfMonths}
          fromMonth={fromMonth}
        />
      </div>
    );
  }
);

export default DatePickerContainer;
